<style scoped>
    .foot {
        padding-top: 20px;
        margin-top: 20px;
    }
</style>
<template>
    <div style="padding: 20px 0;">
        <div style="font-size: 20px;padding: 0 20px;">
            <div>选择机构</div>
        </div>
        <div style="border-top: 1px solid #f1f1f1;border-bottom: 1px solid #f1f1f1;margin-top: 20px;display: flex;">
            <div style="padding: 0 20px;min-height: 200px;min-width: 280px;border-right: 1px solid #f1f1f1;">
                <div v-if="!jigous.length">
                    <div style="color: #aaa;min-height: 200px;" class="center">
                        <div>暂无数据</div>
                    </div>
                </div>
                <div v-else>
                    <div class="df">
                        <Tabs v-model="querytype" :animated="false" @on-click="querytypeChanged">
                            <TabPane label="按组织筛选" name="anzuzhi" />
                            <TabPane label="按标签筛选" name="anbiaoqian" v-if="biaoqianleixing!='none'" />
                        </Tabs>
                        <!-- <div style="padding:14px 16px;font-weight: bold;border-bottom: 1px solid #eaeaea;">按组织筛选</div> -->
                    </div>
                    <div v-if="querytype=='anzuzhi'">
                        <div style="padding: 5px 16px;">
                            <Tree :data="treeData" @on-check-change="treeSelected" show-checkbox expand-node></Tree>
                        </div>
                    </div>
                    <div v-else-if="querytype=='anbiaoqian'">
                        <div style="padding: 5px 16px;" v-if="biaoqians">
                            <Tree :data="biaoqiantree" @on-check-change="biaoqiantreeSelected" show-checkbox expand-node></Tree>
                        </div>
                    </div>
                </div>
            </div>
            <div style="width: 100%;">
                <div style="padding: 10px;">
                    <Input v-model="query.keywords" icon="ios-search" placeholder="输入名称/编码/地址查询..." style="width: 240px;" @on-enter="keywordsChanged">
                    </Input>
                    <!-- <Button type="primary" @click="showConditions">按条件筛选</Button> -->
                    <Tag v-if="usedKeywords" closable @on-close="clearKeywords" style="height: 32px;line-height: 32px;margin: 0;">
                        搜索：{{usedKeywords}}</Tag>
                    <!-- <Tag v-if="query.relations && query.relations.length" closable @on-close="resetTree" style="height: 32px;line-height: 32px;margin: 0;">
                        仅查看勾选的<span style="color: #20bf64;">{{query.relations.length}}</span>个机构范围</Tag> -->
                    <Tag v-if="query.selections" closable @on-close="query.selections=null;loadData()" style="height: 32px;line-height: 32px;margin: 0;">
                        仅查看包含在 <span style="color: #20bf64;"> {{query.selections.filter(o=>(o.actived===undefined || o.actived) && o.type != 'JG' && o.type!='BM').length}}</span> 个已选项中的内容</Tag>
                </div>
                <div v-if="mendians.length">
                    <Table :columns="columns1" :loading="loading" :data="mendians" @on-select="itemSelected" @on-select-cancel="itemSelectedCancel" @on-select-all="allSelected" @on-select-all-cancel="allSelectedCancel"></Table>
                    <div v-if="mendians.length < total" style="float:right">
                        <Page size="small" placement="top" :total="total" :current="page.current" @on-page-size-change="pageSizeChanged" show-sizer :page-size-opts="[10,20,40,100]" :page-size="page.size" @on-change="pageChanged" show-total style="padding: 16px;"></Page>
                    </div>
                </div>
                <div v-if="!mendians.length" class="center" style="color: #aaa;min-height: 200px;">暂无数据</div>
                <div style="padding: 16px 20px;">
                    <div style="display: flex;align-items: center;">
                        已选<span style="color: #20bf64;margin: 0 4px;">{{selections.filter(o=>(o.actived===undefined || o.actived)&& o.type!='JG' && o.type!='BM').length}}</span>项
                        <Poptip trigger="hover">
                            <Icon type="ios-information-circle-outline" style="color: #aaa;margin-left: 2px;"></Icon>
                            <div slot="content" style="color:#aaa;">
                                <div style="width: 520px; word-wrap: break-word; white-space: normal;">
                                    列表中的数据仅显示了当前登录账号有权限管辖且启用中的机构，已选总数则统计的是被编辑的账号完整管辖机构数据，不受当前登录账号的权限和查询条件等限制。
                                </div>
                            </div>
                        </Poptip>
                        <div v-if="selections.length" style="display: flex;">
                            <div @click="showSelections" style="color: #20bf64;margin-left: 10px;" class="hover">查看</div>
                            <div @click="clearSelections" style="color: #20bf64;margin-left: 10px;" class="hover">取消选择</div>
                            <div @click="selectall" style="color: #20bf64;margin-left: 10px;" class="hover" v-if="selections.length!=total">选择全部{{total}}项</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot jcsb" style="padding: 0 20px;">
            <div>
            </div>
            <div class="center">
                <Button @click="cancel" style="margin-right: 10px;">取消</Button>
                <Button type="primary" @click="mendianSelected">确定</Button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            current: Array,
            // 禁用id
            disabledId: {
                type: null,
                default: null
            },
            options: null,
            biaoqianleixing: String,
        },
        data() {
            return {
                biaoqians: null,
                querytype: 'anzuzhi',
                loading: false,
                query: {
                    keywords: '',
                    init: true,
                    biaoqianIds: [],
                },
                usedKeywords: '',
                page: {
                    current: 1,
                    size: 5,
                },
                total: 0,
                mendians: [],
                columns1: [
                    { type: 'selection', align: 'center', width: 60, },
                    { title: '机构名称', key: 'name', },
                    { title: '编码', key: 'code', },
                    { title: '地址', key: 'address', },
                ],
                selections: [],
                treeData: [],
                jigous: [],
                biaoqiantree: [],
                isAdmin: this.$store.session.zhanghao.guanxiajigous.some(o => o.type == 'ZB'),
            }
        },
        mounted() {
            if (this.current) this.selections = this.current.map(item => { return item }) //使用map中断引用传递
            // this.$set(this.page, 'size', Number(sessionStorage.pagesize || 10))
            if (this.options) {
                if (this.options.query) {
                    for (let key of Object.keys(this.options.query)) {
                        this.query[key] = this.options.query[key];
                    }
                }
            }
            this.loadData()
        },
        methods: {
            async selectall() {
                if (this.loading) return
                this.loading = true
                let res = await this.$api.post('/web/main/mendianselector/selectall', {
                    query: this.query,
                    fields: {
                        _id: 1,
                        name: 1,
                        code: 1,
                        type: 1,
                        level: 1,
                        parent: 1,
                        relations: 1,
                        address: 1,
                        jingyingfangshi: 1,
                    },
                })
                if (res.data.items) {
                    for (let item of res.data.items) {
                        if (!this.selections.findOne({ _id: item._id })) {
                            this.selections.push(item)
                        }
                    }

                    this.loadData()
                }
                this.loading = false
            },
            biaoqiantreeSelected(data) {
                this.query.biaoqianIds = data.filter(o => o.checked && o._id).map(o => o._id)
                this.page.current = 1
                this.loadData()
            },
            async biaoqianSelected() {
                this.page.current = 1
                this.loadData()
            },
            async querytypeChanged(value) {
                this.query.biaoqianIds = []
                if (value == 'anbiaoqian') {
                    let res = await this.$api.post('/web/main/mendianselector/loadbiaoqians', {
                        biaoqianleixing: this.biaoqianleixing
                    })
                    this.biaoqians = res.data.biaoqians
                    this.loadBiaoqiantree()
                }
            },
            loadBiaoqiantree() {
                if (!this.biaoqians) return
                this.biaoqiantree = []
                this.biaoqiantree.push({ name: '全部', title: '全部', expand: true, checked: false, children: [] })
                for (let biaoqian of this.biaoqians) {
                    this.biaoqiantree[0].children.push({ _id: biaoqian._id, name: biaoqian.name, title: biaoqian.name, checked: false, })
                }
            },
            // 禁用选项
            disabledItem() {
                for (const i of this.mendians) {
                    if (i._id === this.disabledId) {
                        i._disabled = true
                    }
                }
            },
            clearTreeChecks() {
                for (let node of this.treeData) {
                    node.checked = false
                    this.clearNode(node)
                }
                this.loadBiaoqiantree()
            },
            clearNode(node) {
                if (node.children) {
                    for (let child of node.children) {
                        child.checked = false
                        this.clearNode(child)
                    }
                }
            },
            resetTree() {
                this.query.relations = null
                this.clearTreeChecks()
                this.page.current = 1
                this.loadData()
            },
            treeSelected(nodes) {
                this.query.relations = nodes.map((item) => { return { _id: item._id, name: item.name } })
                for (let node of nodes) {
                    this.parseNode(node)
                }
                this.page.current = 1
                this.loadData()
            },
            parseNode() {
                // if (node.checked && node.children) {
                //     for (let child of node.children) {
                //         if (!child.checked) {
                //             child.checked = true
                //             this.query.relations.push({ _id: child._id, name: child.name })
                //             this.parseNode(child)
                //         }
                //     }
                // }
            },
            clearKeywords() {
                this.query.keywords = ''
                this.usedKeywords = ''
                this.page.current = 1
                this.loadData()
            },
            keywordsChanged() {
                this.usedKeywords = this.query.keywords
                this.page.current = 1
                this.loadData()
            },
            pageChanged(value) {
                this.page.current = value
                this.loadData()
            },
            pageSizeChanged(value) {
                this.page.size = value
                // sessionStorage.pagesize = value
                if (this.page.current == 1) this.loadData()
            },
            loadData() {
                let that = this
                that.loading = true
                that.$api.post('/web/main/mendianselector/load', {
                    query: this.query,
                    page: this.page,
                }).then(res => {
                    that.loading = false
                    if (that.query.init) {
                        that.query.init = false
                        that.jigous = res.data.jigous
                        that.parseTree(that.jigous)
                    }
                    that.total = res.data.total
                    that.usedKeywords = that.query.keywords
                    let mendians = res.data.mendians
                    for (let mendian of mendians) {
                        let found = that.selections.findOne({ _id: mendian._id })
                        if (found) {
                            mendian._checked = true
                        }
                    }
                    that.mendians = mendians
                    if (that.disabledId) {
                        that.disabledItem()
                    }
                }, () => {
                    that.loading = false
                })
            },
            parseTree(jigous) {
                let treeData = []
                let maxlevel = 0
                let items = []
                for (let jigou of jigous) {
                    if (jigou.level > maxlevel) {
                        maxlevel = jigou.level
                    }
                    items.push({ _id: jigou._id, name: jigou.name, level: jigou.level, parent: jigou.parent, title: jigou.name, checked: false, expand: jigou.level < 1 ? true : false, children: [], })
                }
                let level = maxlevel
                while (level >= 0) {
                    for (let item of items) {
                        if (item.level == level) {
                            if (!item.parent) {
                                treeData.push(item)
                            } else {
                                for (let parent of items) {
                                    if (parent._id == item.parent._id) {
                                        parent.children.push(item)
                                    }
                                }
                            }
                        }
                    }
                    level--
                }
                // for (let item of items) {
                //     let allchildren = this.getAllChildren(item)
                //     if (allchildren.some(o => o.checked) && allchildren.some(o => !o.checked)) {
                //         item.expand = true
                //     } else {
                //         item.expand = false
                //     }
                // }
                this.treeData = treeData
            },
            search() {
                this.loadData()
            },
            cancel() {
                this.$emit('cancel')
            },
            mendianSelected() {
                this.$emit('mendianSelected', this.selections)
            },

            showSelections() {
                let selections = this.selections.map(item => { return { _id: item._id, actived: item.actived, type: item.type } })
                this.query = { selections }
                if (this.options) {
                    if (this.options.query) {
                        for (let key of Object.keys(this.options.query)) {
                            this.query[key] = this.options.query[key];
                        }
                    }
                }
                this.page.current = 1
                this.clearTreeChecks()
                this.loadData()
            },
            clearSelections({ confirm }) {
                if (!this.isAdmin && this.$store.session.zhanghao.guanxiajigous && this.$store.session.zhanghao.guanxiajigous.length * this.selections.length > 1000000 && !confirm) {
                    this.$Modal.confirm({
                        title: '提示',
                        content: '机构数量较多，清空需要一定时间，点击确定继续',
                        onOk: () => {
                            this.clearSelections({ confirm: true })
                        }
                    })
                    return
                }
                if (this.$store.session.zhanghao.guanxiajigous && !this.isAdmin) {
                    this.selections = this.selections.filter(o => { return !this.$store.session.zhanghao.guanxiajigous.some(j => { return j._id == o._id }) })
                } else {
                    this.selections = []
                }
                let mendians = []
                for (let item of this.mendians) {
                    item._checked = false
                    mendians.push(item)
                }
                this.mendians = mendians
            },
            allSelected(items) {
                for (let item of items) {
                    if (!this.selections.findOne({ _id: item._id })) {
                        this.selections.push(item)
                    }
                }
            },
            allSelectedCancel() {
                for (let item of this.mendians) {
                    this.selections.remove({ _id: item._id })
                }
            },
            itemSelected(_, item) {
                this.selections.push(item)
            },
            itemSelectedCancel(_, item) {
                this.selections.remove({ _id: item._id })
            },

        },
    };
</script>


// WEBPACK FOOTER //
// src/components/common/MendianSelector.vue?c0cffa8a